import { render, staticRenderFns } from "./SelectVT.vue?vue&type=template&id=639316f2&scoped=true"
import script from "./SelectVT.vue?vue&type=script&lang=js"
export * from "./SelectVT.vue?vue&type=script&lang=js"
import style0 from "./SelectVT.vue?vue&type=style&index=0&id=639316f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639316f2",
  null
  
)

export default component.exports